import { render } from "./LeitorCodigoCamera.vue?vue&type=template&id=685a7ecc&ts=true"
import script from "./LeitorCodigoCamera.vue?vue&type=script&lang=ts"
export * from "./LeitorCodigoCamera.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__